import { ShortcutsAction, ShortcutsActionNames } from "./actions";

export interface IShortcutsState {
  enabled: boolean;
}

export const initialState = {
  enabled: true,
};

const shortcutsReducer = (state: IShortcutsState = initialState, action: ShortcutsAction): IShortcutsState => {
  switch (action.type) {
    case ShortcutsActionNames.DISABLE:
      return {
        ...state,
        enabled: false,
      };
    case ShortcutsActionNames.ENABLE:
      return {
        ...state,
        enabled: true,
      };
    default:
      return state;
  }
};

export default shortcutsReducer;
